module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_3000_Inactive@1x-20aec27b2fd8ac38da6c4aec303600d4.png";